module.exports = __webpack_public_path__ + "media/dashboard/assets/images/sidebar/message-dd4578b3d4147e00bce0690db85e194f.svg";